import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './password-reset.page.html',
  styleUrls: ['./password-reset.page.scss']
})
export class PasswordResetPage implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
